import htmlError from "../utils/xml-parsers/html-error";
import { parsePolicy } from "../utils/xml-parsers/policy-parser";
import { getApiUrl } from "../utils/get-api-url";

export const getPolicy = async ({ id, auth }) => {
  if (!id) return Promise.reject("Policy ID is required to get the policy");
  const apiUrl = getApiUrl("pxcentral");
  const fullUrl = `${apiUrl}/policies/${id}`;

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include",
    headers: {
      "X-Authorization": auth,
      Accept: "application/xhtml+xml",
      "Content-Type": "application/xhtml+xml"
    }
  });

  const { ok } = response;

  if (!ok) {
    const errorBody = await response.text();
    return Promise.reject(htmlError(errorBody));
  }

  const xml = await response.text();
  try {
    return Promise.resolve(parsePolicy(xml));
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getPolicyWithoutAuth = async ({ quoteId }) => {
  if (!quoteId)
    return Promise.reject("Policy ID is required to get the policy");
  const apiUrl = getApiUrl("pxcentral");
  const fullUrl = `${apiUrl}/policies/${quoteId}`;

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/xhtml+xml",
      "Content-Type": "application/xhtml+xml"
    }
  });

  const { ok } = response;

  if (!ok) {
    const errorBody = await response.text();
    return Promise.reject(htmlError(errorBody));
  }

  const xml = await response.text();
  try {
    return Promise.resolve(parsePolicy(xml));
  } catch (error) {
    return Promise.reject(error);
  }
};
